import apiService from './api-service';

export const fuelFlowMeterService = {
    getFuelFlowMeters,
    getFuelFlowMetersInfo
};

async function getFuelFlowMeters() {
    const fuelFlowMeters = await apiService.get('fuelflowmeter/getFuelFlowMeters');

    return fuelFlowMeters;
}

async function getFuelFlowMetersInfo() {
    const fuelFlowMetersInfo = await apiService.get('fuelflowmeter/getFuelFlowMetersInfo');

    return fuelFlowMetersInfo;
}